module.exports = __webpack_public_path__ + "img/雨量实况.2621c3c7.png";